export const ALLOWED_GSTIN_PROGRAMS = ["OOC", "INFresh"];
export const GET_SUCCESS_MSG = " finished";
export const GET_FAILED_MSG = " failed. Please retry";
export const GET_INPROGRESS_MSG = " in-progress.";
export const UPDATE_SUCCESS_MSG = "Update in the GSTIN allowlist has been initiated. " +
    "Changes will be reflected after 10~15 minutes.";
export const UPDATE_FAILED_MSG = "Update Failed! Please retry!";
export const UPDATE_TASK = "update";